import { I18n } from 'common/i18n';
import * as filters from 'common/components/AssetBrowser/actions/filters';
import { Filters } from 'common/components/AssetBrowser/lib/helpers/enabled_filters';
import { SelectDropdownConfig } from './filter-config';
import { getForgeIconNameForDisplayType } from 'common/displayTypeMetadata';
import { FeatureFlags } from '@socrata/platform/feature-flags';
import { FilterScope, getAllOption, getScope } from './translations';
import { FilterType } from './types';
import { IBaseListDropdownOption } from '@tylertech/forge/esm/list-dropdown';

const scope = getScope(FilterScope.AssetTypes);

export const getAssetTypeOptions = (): IBaseListDropdownOption<string | null>[] => {
  const assetTypeOptions: IBaseListDropdownOption<string | null>[] = [
    getAllOption(scope),
    {
      label: I18n.t('options.calendars', { scope }),
      value: 'calendars',
      leadingIcon: getForgeIconNameForDisplayType('calendar'),
      leadingIconType: 'component',
    },
    {
      label: I18n.t('options.charts', { scope }),
      value: 'charts',
      leadingIcon: getForgeIconNameForDisplayType('chart'),
      leadingIconType: 'component',
    },
    {
      label: I18n.t('options.datasets', { scope }),
      value: 'datasets,system_datasets', // dataset
      leadingIcon: getForgeIconNameForDisplayType('dataset'),
      leadingIconType: 'component',
    },
    {
      label: I18n.t('options.external', { scope }),
      value: 'hrefs,federated_hrefs', // aka external datasets
      leadingIcon: getForgeIconNameForDisplayType('href'),
      leadingIconType: 'component',
    },
    {
      label: I18n.t('options.files', { scope }),
      value: 'files',
      leadingIcon: getForgeIconNameForDisplayType('attachment'),
      leadingIconType: 'component',
    },
    {
      label: I18n.t('options.filtered', { scope }),
      value: 'filters',
      leadingIcon: getForgeIconNameForDisplayType('filter'),
      leadingIconType: 'component',
    },
    {
      label: I18n.t('options.forms', { scope }),
      value: 'forms',
      leadingIcon: getForgeIconNameForDisplayType('form'),
      leadingIconType: 'component',
    },
    {
      label: I18n.t('options.maps', { scope }),
      value: 'maps',
      leadingIcon: getForgeIconNameForDisplayType('map'),
      leadingIconType: 'component',
    },
    {
      label: I18n.t('options.system_datasets', { scope }),
      value: 'system_datasets',
      leadingIcon: getForgeIconNameForDisplayType('system_dataset'),
      leadingIconType: 'component',
    },
  ];

  if (FeatureFlags.value('open_performance_standalone_measures')) {
    assetTypeOptions.push({
      label: I18n.t('options.measures', { scope }),
      value: 'measures',
      leadingIcon: getForgeIconNameForDisplayType('measure'),
      leadingIconType: 'component',
    });
  }

  if (FeatureFlags.value('stories_enabled')) {
    assetTypeOptions.push({
      label: I18n.t('options.stories', { scope }),
      value: 'stories',
      leadingIcon: getForgeIconNameForDisplayType('story'),
      leadingIconType: 'component',
    });
  }

  return assetTypeOptions;
};

export const assetTypeConfigs: SelectDropdownConfig = {
  filterName: Filters.AssetTypes,
  label: I18n.t('label', { scope }),
  getOptions: getAssetTypeOptions,
  dispatchAction: filters.changeAssetType,
  filterType: FilterType.SelectDropdown,
};
